import React, { PropsWithChildren, FC, useEffect, useState, useRef, ReactNode } from 'react';
import { View } from '@tarojs/components';

interface IModalContainerProps {
  visible: boolean;
}

const Container: FC<PropsWithChildren<IModalContainerProps>> = ({ children, visible = false }) => {
  return visible ? <View>{children}</View> : null;
};

interface IModalProps {
  title?: string;
  content: ReactNode;
  visible?: boolean;
  maskClosable?: boolean;
  okText: string;
  onOk?: () => void;
  onClose?: () => void;
}

const Modal: FC<IModalProps> = ({ title = '', content, visible: inputVisible = false, maskClosable = true, okText = '', onOk, onClose }) => {
  const [cut, setCut] = useState('');
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<any>(null);

  const destroyModal = (type: 'ok' | 'close') => {
    setCut('leave');
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    timerRef.current = setTimeout(() => {
      setVisible(false);
      if (type === 'ok' && onOk) {
        onOk();
      }
      if (type === 'close' && onClose) {
        onClose();
      }
    }, 300);
  };

  const onMaskClick = () => {
    if (maskClosable) {
      destroyModal('close');
    }
  };

  const selfOnOk = () => {
    destroyModal('ok');
  };

  useEffect(() => {
    setVisible(inputVisible);
    if (inputVisible) {
      setCut('enter');
    }
    return () => {
      setCut('');
    };
  }, [inputVisible]);

  return (
    <Container visible={visible}>
      <View className={`ace-modal ${cut ? `ace-modal__${cut}` : ''}`}>
        <View onClick={onMaskClick} className="ace-modal-mask" />
        <View className="ace-modal-container">
          {title && <View className="ace-modal-title">{title}</View>}
          <View className={`ace-modal-content ${title && 'ace-modal-content__a'}`}>{content}</View>
          {okText && (
            <View className="ace-modal-btn" onClick={selfOnOk}>
              {okText}
            </View>
          )}
        </View>
      </View>
    </Container>
  );
};

export default Modal;
